export default __webpack_public_path__ + "c6279d5199798693ae86656543cbbbcc.svg";